(function () {
  var selector = '[data-collection-description]';
  var resizeTimer;

  function setExpanded(wrapper, expanded) {
    var button = wrapper.querySelector('[data-collection-description-toggle]');
    var label = wrapper.querySelector('[data-collection-description-label]');

    wrapper.classList.toggle('is-expanded', expanded);
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    label.textContent = expanded
      ? wrapper.dataset.readLessLabel
      : wrapper.dataset.readMoreLabel;
  }

  function updateCollapsibility(wrapper) {
    var content = wrapper.querySelector('[data-collection-description-content]');
    var button = wrapper.querySelector('[data-collection-description-toggle]');
    var wasExpanded = wrapper.classList.contains('is-expanded');
    var styles;
    var lineHeight;

    wrapper.classList.remove('is-collapsible', 'is-expanded');
    button.hidden = true;

    styles = window.getComputedStyle(content);
    lineHeight = parseFloat(styles.lineHeight);

    if (!lineHeight || content.scrollHeight <= lineHeight * 3 + 1) {
      button.setAttribute('aria-expanded', 'false');
      return;
    }

    wrapper.classList.add('is-collapsible');
    button.hidden = false;
    setExpanded(wrapper, wasExpanded);
  }

  function initCollectionDescription(wrapper) {
    var button;

    if (wrapper.dataset.collectionDescriptionInitialized === 'true') {
      updateCollapsibility(wrapper);
      return;
    }

    button = wrapper.querySelector('[data-collection-description-toggle]');
    if (!button) return;

    wrapper.dataset.collectionDescriptionInitialized = 'true';
    button.addEventListener('click', function () {
      setExpanded(wrapper, button.getAttribute('aria-expanded') !== 'true');
    });

    updateCollapsibility(wrapper);
  }

  function initAll(root) {
    var descriptions = root.querySelectorAll(selector);

    descriptions.forEach(initCollectionDescription);
  }

  function refreshAll() {
    document.querySelectorAll(selector).forEach(updateCollapsibility);
  }

  function onReady() {
    initAll(document);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refreshAll);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(refreshAll, 150);
  });

  window.addEventListener('load', refreshAll);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
